import { render, staticRenderFns } from "./BAEventSponsorAdminPage.vue?vue&type=template&id=28576e96&scoped=true&"
import script from "./BAEventSponsorAdminPage.vue?vue&type=script&lang=ts&"
export * from "./BAEventSponsorAdminPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28576e96",
  null
  
)

export default component.exports